import { $$tracker } from '@src/tracker';

const trackerMap = {
  youtube_link: $$tracker.clickYoutube,
  twitter_link: $$tracker.clickXxx,
  discord_link: $$tracker.clickDiscord,
  steam_link: $$tracker.clickDlcmsmkSteam
};

function goToShare(type) {
  trackerMap[type]?.();
  let url = window.mechabreakConfig[type];
  if (url) {
    window.open(window.mechabreakConfig[type]);
  }
}

export default goToShare;
